// configuration
export const SEEK_THROTTLE_INTERVAL = 50;
export const MOUSE_MOVE_HIDE_THROTTLE_INTERVAL = 500;
export const HIDE_OVERLAY_TIMEOUT = 3000;
export const PLAYER_SPEED_OPTIONS = [0.25, 0.5, 1, 1.5, 2];

// actions
export const PLAY = 'player:request:play';
export const PAUSE = 'player:request:pause';
export const SET_MEDIA = 'player:request:set-media';
export const PLAY_MEDIA = 'player:request:play-media';
export const SEEK = 'player:request:SEEK';
export const SEEK_INTERVAL = 'player:request:SEEK_INTERVAL';
export const SEEK_TO_LIVE = 'player:request:SEEK_TO_LIVE';
export const SEEK_TAG = 'player:request:SEEK_TAG';
export const SEEK_NEXT_TAG = 'player:request:SEEK_NEXT_TAG';
export const SEEK_PREVIOUS_TAG = 'player:request:SEEK_PREVIOUS_TAG';
export const SEEK_LAST_TAG = 'player:request:SEEK_LAST_TAG';
export const SET_VOLUME = 'player:request:SET_VOLUME';
export const SNAP = 'player:request:SNAP';
export const SET_QUALITY = 'player:request:SET_QUALITY';
export const MUTE = 'player:request:MUTE';
export const UNMUTE = 'player:request:UNMUTE';
export const END = 'player:request:END';

// interaction
export const SEEK_BACKWARD_TAP_COUNT = 2;
export const SEEK_FORWARD_TAP_COUNT = 3;

export const ACTIONS = {
	PLAY,
	PAUSE,
	SET_MEDIA,
	PLAY_MEDIA,
	SEEK,
	SEEK_INTERVAL,
	SEEK_TO_LIVE,
	SEEK_TAG,
	SEEK_NEXT_TAG,
	SEEK_PREVIOUS_TAG,
	SEEK_LAST_TAG,
	SET_VOLUME,
	SNAP,
	SET_QUALITY,
	MUTE,
	UNMUTE,
	END,
};
